import { TagSelector, TagSelectorContextModel } from "./tag-selector-state";

export class PatchState {
  public static readonly type = "[Tag Selector] Patch State";
  constructor(public state: Partial<TagSelectorContextModel>) {}
}

export class PatchSelector {
  public static readonly type = "[Tag Selector] Patch Selector";
  constructor(
    public friendlyId: string,
    public selector: Partial<TagSelector>,
    public key: string
  ) {}
}

export class AddSelector {
  public static readonly type = "[Tag Selector] Add Selector";
  constructor(public selector: TagSelector) {}
}

export class DeleteSelector {
  public static readonly type = "[Tag Selector] Delete Selector";
  constructor(
    public friendlyId: string,
    public key: string
  ) {}
}
